<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />

    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <h4>Información del Centro de Atención Médica</h4>
          </div>
        </div>
        <div class="col-1">
          <span
            class="material-symbols-outlined"
            style="font-size: 32px; color: blue; cursor: pointer"
            @click="showModalHelp = true"
            >help
          </span>
        </div>
      </div>
    </div>
    <!-- Area de notificación -->
    <div
      class="notification-area"
      v-for="(notificacion, index) in notificaciones"
      :key="index"
    >
      <div
        class="notification-message"
        :class="{
          'is-success': notificacion.type === 'success',
          'is-error': notificacion.type === 'error',
        }"
      >
        {{ notificacion.message }}
      </div>
    </div>

    <hr />
    <!-- Modal -->
    <div class="modal-dialog modal-xl" style="z-index: 1">
      <div class="modal-content">
        <form>
          <div class="modal-body">
            <!-- Botón Lista de Valores  Tipo Iden -->
            <!--
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idTipoIden" class="form-label"> Tipo Iden</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idTipoIden" name="idTipoIden" v-model="datoEmpresa.idTipoIden">
                      <option v-for="tipoIden in tipoIdens" :value="tipoIden.idTipoIden" :key="tipoIden.idTipoIden">
                        {{ tipoIden.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
-->
            <!-- Botón Lista de Valores  Tipo Iden -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombreCorto" class="form-label"
                    >Nombre Corto</label
                  >
                </div>
                <div class="col-2">
                  <input
                    type="text"
                    class="form-control"
                    id="nombreCorto"
                    name="nombreCorto"
                    v-model="datoEmpresa.nombreCorto"
                    style="text-transform: uppercase"
                    disabled
                  />
                </div>
                <div class="col-1">
                  <label for="documento" class="form-label">Documento</label>
                </div>
                <div class="col-2">
                  <input
                    type="text"
                    class="form-control"
                    id="documento"
                    name="documento"
                    v-model="datoEmpresa.documento"
                    style="text-transform: uppercase"
                    disabled
                  />
                </div>
                <div class="col-1">
                  <label for="localidad" class="form-label">Localidad</label>
                </div>
                <div class="col-4">
                  <input
                    type="text"
                    class="form-control"
                    id="localidad"
                    name="localidad"
                    v-model="datoEmpresa.localidadNombre"
                    disabled
                  />
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="razonSocial" class="form-label"
                    >Razón Social</label
                  >
                </div>
                <div class="col-5">
                  <input
                    type="text"
                    class="form-control"
                    id="razonSocial"
                    name="razonSocial"
                    v-model="datoEmpresa.razonSocial"
                    style="text-transform: uppercase"
                    disabled
                  />
                </div>
                <div class="col-1">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-4">
                  <input
                    type="text"
                    class="form-control"
                    id="nombre"
                    name="nombre"
                    v-model="datoEmpresa.nombre"
                    style="text-transform: uppercase"
                    disabled
                  />
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="direccion" class="form-label">Dirección</label>
                </div>
                <div class="col-10">
                  <textarea
                    class="form-control"
                    id="direccion"
                    name="direccion"
                    v-model="datoEmpresa.direccion"
                    style="text-transform: uppercase"
                    disabled
                  ></textarea>
                </div>
              </div>
            </div>
            <button @click.prevent="mostrarOcultarBloque">
              {{
                mostrarBloque ? "(-) Menos información" : "(+) Más información"
              }}
            </button>
            <div v-if="mostrarBloque" class="mb-3">
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idEmpresa" class="form-label">IdEmpresa</label>
                    <input
                      type="text"
                      class="form-control"
                      id="idEmpresa"
                      name="idEmpresa"
                      v-model="datoEmpresa.idEmpresa"
                      disabled
                    />
                  </div>
                  <div class="col-2">
                    <label for="idUsuarioReg" class="form-label"
                      >IdUsuarioReg</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="idUsuarioReg"
                      name="idUsuarioReg"
                      v-model="datoEmpresa.idUsuarioReg"
                      style="text-transform: uppercase"
                      disabled
                    />
                  </div>
                  <div class="col-3">
                    <label for="fechaReg" class="form-label"
                      >Fecha de registro</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="fechaReg"
                      name="fechaReg"
                      :value="getFormattedDate(datoEmpresa.fechaReg)"
                      disabled
                    />
                  </div>
                  <div class="col-2">
                    <label for="idUsuarioAct" class="form-label"
                      >IdUsuarioAct</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="idUsuarioAct"
                      name="idUsuarioAct"
                      v-model="datoEmpresa.idUsuarioAct"
                      style="text-transform: uppercase"
                      disabled
                    />
                  </div>
                  <div class="col-3">
                    <label for="fechaAct" class="form-label">FechaAct</label>
                    <input
                      type="text"
                      class="form-control"
                      id="fechaAct"
                      name="fechaAct"
                      :value="getFormattedDate(datoEmpresa.fechaAct)"
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="tabs">
      <button
        class="tablink"
        @click="showTable = 'suscripcion'"
        :class="{ 'active-tab': showTable === 'suscripcion' }"
        v-if="suscriptor == 1"
      >
        <i
          class="material-icons"
          style="font-size: 24px; color: red; cursor: pointer"
          >card_membership</i
        >
        Suscripción
      </button>
      <button
        class="tablink"
        @click="showTable = 'personas'"
        :class="{ 'active-tab': showTable === 'personas' }"
        v-if="suscriptor == 1"
      >
        <span
          class="material-symbols-outlined"
          style="font-size: 24px; color: red; cursor: pointer"
          >groups</span
        >
        Personas
      </button>
      <button
        class="tablink"
        @click="showTable = 'usuarios'"
        :class="{ 'active-tab': showTable === 'usuarios' }"
        v-if="suscriptor == 1"
      >
        <span
          class="material-symbols-outlined"
          style="font-size: 24px; color: red; cursor: pointer"
          >account_circle</span
        >
        Usuarios
      </button>
<!--
      <button
        class="tablink"
        @click="showTable = 'medios'"
        :class="{ 'active-tab': showTable === 'medios' }"
      >
        <i
          class="material-icons"
          style="font-size: 24px; color: red; cursor: pointer"
          >phone_in_talk</i
        >
        Medios de Comunicación
      </button>
      <button
        class="tablink"
        @click="showTable = 'logos'"
        :class="{ 'active-tab': showTable === 'logos' }"
      >
        <i
          class="material-icons"
          style="font-size: 24px; color: red; cursor: pointer"
          >phone_in_talk</i
        >
        Logos
      </button>
-->
    </div>
    <div v-if="showTable === 'suscripcion' && dataLoaded">
      <SuscripcionEmpr :p_idEmpresa="p_idEmpresa"></SuscripcionEmpr>
    </div>
    <div v-if="showTable === 'personas'">
      <PersonaEmpr :p_idEmpresa="p_idEmpresa"></PersonaEmpr>
    </div>
    <div v-if="showTable === 'usuarios'">
      <UsuarioEmpr :p_idEmpresa="p_idEmpresa"></UsuarioEmpr>
    </div>
<!--
    <div v-if="showTable === 'medios'">
      <MedioEmp :p_idEmpresa="p_idEmpresa"></MedioEmp>
    </div>
    <div v-if="showTable === 'logos'">
      <EmpresaImg :p_idEmpresa="p_idEmpresa"></EmpresaImg>
    </div>
-->
    <Footer />
  </div>
</template>
<script>

import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";
//import MedioEmp from "../forms/MedioEmp.vue";
import UsuarioEmpr from "../forms/UsuarioEmpr.vue";
import PersonaEmpr from "../forms/PersonaEmpr.vue";
import SuscripcionEmpr from "../forms/SuscripcionEmpr.vue";
/*
import EmpresaImg from "../forms/EmpresaImg.vue";
*/
import dateFormat from "@/modules/dateFormat.js";


import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
export default {
  components: {
    Layout,
    Footer,
//    MedioEmp,
    UsuarioEmpr,
    PersonaEmpr,
    SuscripcionEmpr,
//    EmpresaImg,
  },
  data() {
    return {
      empresas: [],
      datoEmpresa: {},
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      modalWindow: true,
      p_idEmpresa: 0,
      suscriptor: 0,
      // localidads: [],
      // tipoIdens: [],
      showTable: "suscripcion",
      mostrarBloque: false,
      dataLoaded: false,
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px",
      },
    };
  },
  mounted() {
    this.p_idEmpresa = this.$route.params.p_idempresa;
    this.suscriptor = window.sessionStorage.getItem("suscriptor");
    this.getData();
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    // this.fetchLocalidads()
    // this.fetchTipoIdens()
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    mostrarOcultarBloque() {
      this.mostrarBloque = !this.mostrarBloque;
    },
    getData() {
      api.get("/vwempresas/" + this.p_idEmpresa)
        .then((response) => {
          this.datoEmpresa = response.data;
          this.dataLoaded = true;
        })
        .catch((error) => {
          console.error("Error al obtener datos de la persona:", error);
        });
    },
    openHelp() {
      this.popupAyuda = true;
      this.$refs.helpPopup.open();
    },
    handlePopupClosed() {
      this.popupAyuda = false;
    },
    /*     fetchLocalidads() {
      fetch(config.apiBaseUrl + '/localidads')
        .then(response => response.json())
        .then(data => {
          this.localidads = data;
        })
        .catch(error => {
          console.error('Error fetching localidads:', error);
        });
    },
    fetchTipoIdens() {
      fetch(config.apiBaseUrl + '/tipoidens')
        .then(response => response.json())
        .then(data => {
          this.tipoIdens = data;
        })
        .catch(error => {
          console.error('Error fetching tipoIdens:', error);
        });
    }, */
  },
};
</script>

<style src="@/assets/css/tabs.css" scoped></style>
